export enum ApiErrorsTypes {
  GetApiErrorsRequest = 'SearchService.GetApiErrors.Request',
  GetApiErrorsSuccess = 'SearchService.GetApiErrors.Success',
  GetApiErrorsFailure = 'SearchService.GetApiErrors.Failure',
}
